var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('road-card',{staticClass:"mb-4",attrs:{"road":_vm.road}}),_c('road-driver',{attrs:{"road":_vm.road}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }